import { render, staticRenderFns } from "./all.vue?vue&type=template&id=5c5a12e8&scoped=true"
import script from "./all.vue?vue&type=script&lang=js"
export * from "./all.vue?vue&type=script&lang=js"
import style0 from "./all.vue?vue&type=style&index=0&id=5c5a12e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a12e8",
  null
  
)

export default component.exports